import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import * as actions from './redux/supplierAction';
import { Row, Col, Form, Input, Label, Button, Container } from 'src/components/Common/reactstrap/lib';
import serialize from '../../logic/serialize';
import Breadcrumbs from 'src/components/Breadcrumbs/Breadcrumbs';


class SupplierRegistration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputs: {},
      selectedLegalType: 1,
      desableSubmit: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event, count, numeric) {
    const target = event.target,
      name = target.name;

    let value = target.value,
      disabled;

    if(!value)
    {
      disabled = true;
    }
    else {
      disabled =
        _.size(this.state.inputs) < 10 && +this.state.selectedLegalType !== 1
        ||
        _.size(this.state.inputs) < 9 && +this.state.selectedLegalType === 1;
    }

    if(numeric)
      value = this.parseNumeric(value, count);
    else
      value = count ? value.substring(0, +count) : value;

    this.setState({
      inputs: {
        ...this.state.inputs,
        [name]: count ? value.substring(0, +count) : value
      },
      desableSubmit: disabled
    });
  }

  parseNumeric(value, count){
    return count ? value.replace(/\D/g,'').substring(0, +count) : value.replace(/\D/g,'');
  }

  handleSubmit(event) {
    event.preventDefault();
    let formData = serialize(event.target, {hash: true});
    this.props.actions.registerSupplier(formData);
  }

  handleLegalTypeChange = (e) => {
    const value = e.target.value;
    const disabled =
      _.size(this.state.inputs) < 10 && +value !== 1
      ||
      _.size(this.state.inputs) < 9 && +value === 1;

    this.setState(
      {
        selectedLegalType: value,
        desableSubmit: disabled
      });
  };

  render() {
    const res = this.props.res;
    if(res.status) return (
      <Container>
        <Breadcrumbs
          routes={this.props.routes}/>
        <div className="mt-3"> Вы успешно зарегистрированы как поставщик.</div>
       <div>На указанный при регистрации почтовый ящик высланы реквизиты доступа в личный кабинет.</div>
        <Button className="mt-3" href="/">На главную</Button>
      </Container>);
    return (
      <Container>
        <Breadcrumbs
          routes={this.props.routes}/>

        <h2>Регистрация поставщика</h2>

        {!res.status && !!res.err
          ? <strong className="text-red">Текст ошибки</strong>
          : null}
        <Form className="row" onSubmit={this.handleSubmit}>
          <Label className="ccol-12">ФИО</Label>
          <Col sm={{ size: 6, pull: 4, offset: 4 }}>
            <Input onChange={this.handleInputChange} name="managerName"/>
          </Col>
          <Label className="ccol-12">Контактный телефон</Label>
          <Col sm={{ size: 2, pull: 8, offset: 8 }}>
            <Input onChange={this.handleInputChange}  name="phone"/>
          </Col>
          <Label className="ccol-12">Эл. почта</Label>
          <Col sm={{ size: 3, pull: 7, offset: 7 }} className="mb-4">
            <Input onChange={this.handleInputChange}  name="email"/>
          </Col>
          <Label className="ccol-12">Название компании</Label>
          <Col sm="1">
            <Input name="supplier[supplierLegal][type][legalTypeId]" type="select" onChange={this.handleLegalTypeChange}>
              <option value="1">ИП</option>
              <option value="2">АО</option>
              <option value="3">ООО</option>
              <option value="4">ОАО</option>
              <option value="5">ЗАО</option>
            </Input>
          </Col>
          <Col sm={{ size: 5, pull: 4, offset: 4 }}>
            <Input onChange={this.handleInputChange} name="supplier[supplierLegal][name]"/>
          </Col>
          <Label className="ccol-12">ИНН</Label>
          <Col sm={{ size: 2, pull: 8, offset: 8 }}>
            <Input
              onChange={(e) => this.handleInputChange(e, 12, true)}
              value={this.state.inputs['supplier[supplierLegal][INN]']}
              name="supplier[supplierLegal][INN]"/>
          </Col>
          {+this.state.selectedLegalType === 1 ? null : <Label className="ccol-12">КПП</Label>}
          {+this.state.selectedLegalType === 1
            ? null
            : <Col sm={{ size: 2, pull: 8, offset: 8 }}>
              <Input
                onChange={(e) => this.handleInputChange(e, 9, true)}
                value={this.state.inputs['supplier[supplierLegal][KPP]']}
                name="supplier[supplierLegal][KPP]"
              />
            </Col>}
          <Label className="ccol-12">БИК</Label>
          <Col sm={{ size: 2, pull: 8, offset: 8 }}>
            <Input
              onChange={(e) => this.handleInputChange(e, 9, true)}
              value={this.state.inputs['supplier[supplierLegal][BIK]']}
              name="supplier[supplierLegal][BIK]"
            />
          </Col>
          <Label className="ccol-12">Расч. счёт</Label>
          <Col sm="3">
            <Input
              onChange={(e) => this.handleInputChange(e, 20, true)}
              value={this.state.inputs['supplier[supplierLegal][paymentAccount]']}
              name="supplier[supplierLegal][paymentAccount]"
            />
          </Col>
          <Label className="ccol-11">Название банка</Label>
          <Col sm={{ size: 2, pull: 4, offset: 4 }}>
            <Input
              onChange={(e) => this.handleInputChange(e, 100)}
              value={this.state.inputs['supplier[supplierLegal][bankName]']}
              name="supplier[supplierLegal][bankName]"/>
          </Col>
          <Label className="ccol-12">Юр. адрес</Label>
          <Col sm={{ size: 6, pull: 4, offset: 4 }} className="mb-4">
            <Input
              onChange={(e) => this.handleInputChange(e, 200)}
              value={this.state.inputs['supplier[supplierLegal][legalAddress]']}
              name="supplier[supplierLegal][legalAddress]"/>
          </Col>
          <Label className="ccol-12"></Label>
          <Col className="col-sm-3" >
            <Button disabled={ this.state.desableSubmit }>Зарегистрироваться</Button>
          </Col>
        </Form>
      </Container>);
  };
}

SupplierRegistration.routeTitle = "Регистрация поставщика";
export default connect(
  (state) => ({
    res: state.supplierReducer
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
  })
)(SupplierRegistration);








/** WEBPACK FOOTER **
 ** ./src/components/Supplier/SupplierRegistration.jsx
 **/